<div class="flex-column gap">
    <app-select-input
        [id]="'headerId'"
        [form]="form"
        label="service.patterns.header"
        [staticOptions]="headers()"
        [valueKey]="'id'"
        class="fr-2">
    </app-select-input>

    <app-select-input
        [id]="'footerId'"
        [form]="form"
        label="service.patterns.footer"
        [staticOptions]="footers()"
        [valueKey]="'id'"
        class="fr-2">
    </app-select-input>
    <app-check-input class="align-self-auto" [form]="form" id="archive" label="common.archive"></app-check-input>
    <app-check-input class="align-self-auto" [form]="form" id="onlyMy" label="voucher.export.onlyMy"></app-check-input>
    <app-date-input
        [form]="form"
        [id]="'date'"
        [selectionMode]="'range'"
        [label]="'inputs.dateRange' | translate"
    ></app-date-input>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons primaryButtonLabel="common.confirm" (primaryClickEvent)="save()"
        (secondaryClickEvent)="dialogRef.close()"></app-action-buttons>
</div>
